import React from 'react';
import { Button } from '../Practice_Test/UI';
import { LogIn, ArrowRight, ChevronLeft, Compass, LucideArrowLeft } from 'lucide-react';

interface UcatFooterProps {
  onEndExam?: () => void;
  onNext?: () => void;
  onPrevious?: () => void;
  onNavigator?: () => void;
  onReview?: () => void;
  showNavigator?: boolean;
  showPrevious?: boolean;
  showReview?: boolean;
  nextDisabled?: boolean;
  previousDisabled?: boolean;
  leftButtonText?: string;
  rightButtonText?: string;
  reviewButtonText?: string;
  customRightActions?: React.ReactNode;
}

export const UcatFooter: React.FC<UcatFooterProps> = ({
  onEndExam,
  onNext,
  onPrevious,
  onNavigator,
  onReview,
  showNavigator = false,
  showPrevious = false,
  showReview = false,
  nextDisabled = false,
  previousDisabled = false,
  leftButtonText = "End Exam",
  rightButtonText = "Next",
  reviewButtonText = "Review",
  customRightActions
}) => {
  return (
    <div className="bg-[#006DAA] h-[35px] flex items-center justify-between">
      {/* Left Side */}
      <div className="flex-1">
        {leftButtonText && (
          <Button
            variant="danger"
            onClick={onEndExam}
            className="!font-[400] !text-[19px] leading-[25px] border-r-[2px] border-white"
            style={{ fontSize: "16px", fontWeight: "normal" }}
          >
            <LogIn
              size={22}
              strokeWidth={3}
              className="mr-2"
            />
            {leftButtonText === "End Exam" || leftButtonText === "End Review" ? (
              <span className="flex items-center !text-[19px] !font-[400] leading-[25px] f-tahoma">
                <span className="relative inline-block !text-[19px] !font-[400]">
                  E
                  <span className="absolute left-0 right-0 bottom-[2px] h-[1.5px] bg-white" />
                </span>
                {leftButtonText === "End Exam" ? "nd Exam" : "nd Review"}
              </span>
            ) : leftButtonText === "Return to Review" ? (
              <span className="flex items-center !text-[19px] !font-[400] leading-[25px] f-tahoma">
                Review &nbsp;
                <span className="relative inline-block !text-[19px] !font-[400]">
                  S
                  <span className="absolute left-0 right-0 bottom-[2px] h-[1.5px] bg-white" />
                </span>
                creen
              </span>
            ) : (
              leftButtonText
            )}
          </Button>
        )}
      </div>

      {/* Right Side */}
      <div className="flex items-center">
        {customRightActions || (
          <>
            {showPrevious && (
              <Button
                variant="danger"
                onClick={onPrevious}
                disabled={previousDisabled}
                className="border-l-[2px] border-white"
                fontWeight={400}
                style={{ fontSize: "19px" }}
              >
                {/* <ChevronLeft size={14} className="mr-1" /> */}
                <LucideArrowLeft size={22} strokeWidth={2.75} className="mr-1" />
                <span className="underline decoration-1 underline-offset-2" style={{ fontSize: "19px" }}>P</span>revious
              </Button>
            )}

            {showNavigator && (
              <Button
                variant="danger"
                onClick={onNavigator}
                fontWeight={400}
                className="border-l-[2px] border-white !font-normal"
                style={{ fontSize: "19px" }}
              >
                <Compass size={16} className="mr-1" />
                Na<span className="underline decoration-1 underline-offset-2" style={{ fontSize: "19px" }}>v</span>igator
              </Button>
            )}

            {showReview && (
              <Button
                variant="danger"
                onClick={onReview}
                className="border-l-[2px] border-white"
                style={{ fontSize: "16px", fontWeight: "normal" }}
              >
                {reviewButtonText}
              </Button>
            )}

            {onNext && (
              <Button
                variant="danger"
                onClick={onNext}
                disabled={nextDisabled}
                className="!font-[400] !text-[19px] leading-[25px] border-l-[2px] border-white flex items-center gap-1"
                style={{ fontSize: "16px", fontWeight: "normal" }}
              >
                {rightButtonText === "Next" ? (
                  <span className="flex items-center !text-[19px] !font-[400] leading-[25px]">
                    <span className="relative inline-block !text-[19px] !font-[400]">
                      N
                      <span className="absolute left-0 right-0 bottom-[2px] h-[1.5px] bg-white" />
                    </span>
                    ext
                  </span>
                ) : (
                  rightButtonText
                )}


                <ArrowRight strokeWidth={2.75} size={22} />
              </Button>
            )}
          </>
        )}
      </div>
    </div>
  );
};
